/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const Help: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.7745 13.8962C10.6854 14.5948 9.39001 15 8 15C6.56944 15 5.2391 14.5709 4.1307 13.8343L6.32945 11.6355C6.83782 11.8695 7.40367 12 8 12C8.55417 12 9.08203 11.8873 9.56189 11.6836L11.7745 13.8962ZM13.8959 11.775C14.5947 10.6858 15 9.3902 15 8C15 6.61001 14.5949 5.31464 13.8962 4.22554L11.6836 6.43817C11.8873 6.91802 12 7.44585 12 8C12 8.55437 11.8872 9.08241 11.6834 9.56241L13.8959 11.775ZM11.775 2.10412L9.56247 4.31667C9.08245 4.11279 8.5544 4 8 4C7.44571 4 6.91775 4.11274 6.43781 4.31655L4.22523 2.10397C5.31439 1.40522 6.60988 1 8 1C9.39023 1 10.6858 1.40527 11.775 2.10412ZM2.10392 4.2253C1.4052 5.31445 1 6.60991 1 8C1 9.42165 1.4238 10.7443 2.15196 11.8486L4.35359 9.64668C4.12645 9.14449 4 8.58701 4 8C4 7.44574 4.11273 6.91782 4.31651 6.43789L2.10392 4.2253ZM5.8687 5.8887C5.33168 6.43079 5 7.17666 5 8C5 9.65685 6.34315 11 8 11C9.65685 11 11 9.65685 11 8C11 6.34315 9.65685 5 8 5C7.17666 5 6.43079 5.33168 5.8887 5.8687L5.8687 5.8887Z'
			/>
		</Svg>
	);
};

export { Help };
